module.exports = __webpack_public_path__ + "img/process-small6.92d57276.png";